import React, { useRef } from "react";
import ButtonGroupNavigation from "components/button_group_navigation";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Switch, Route } from "react-router-dom";
import Favourites from "./Favourites";
import AllReports from "./AllReports";

const useStyles = makeStyles((theme) => ({
  subNavigation: {
    padding: "1rem 0rem 0rem 2rem",
    width: "100%",
  },
}));

export default function Reports(props) {
  const classes = useStyles();
  const buttons = [
    { name: "Favourites", redirect: "/org/reports/sub_reports/favourites" },
    { name: "All Reports", redirect: "/org/reports/sub_reports/all" },
  ];
  const componentRef = useRef();

  return (
    <div>
      <div className={classes.subNavigation}>
        <ButtonGroupNavigation buttons={buttons} {...props} />
      </div>
      <Switch>
        <Route
          exact
          path={"/org/reports/sub_reports/favourites"}
          component={(rprops) => (
            <Favourites {...rprops} {...props} ref={componentRef} />
          )}
          permission={props?.permission}
        />

        <Route
          exact
          path={"/org/reports/sub_reports/all"}
          component={(rprops) => (
            <AllReports {...rprops} {...props} ref={componentRef} />
          )}
          permission={props?.permission}
        />

        <Route component={Favourites} />
      </Switch>
    </div>
  );
}
